
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/coloring-pages-for-kids",
      function () {
        return require("private-next-pages/coloring-pages-for-kids/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/coloring-pages-for-kids"])
      });
    }
  